"use strict";
async function retryOnce(callback, canRetry) {
    try {
        return await callback();
    } catch (e) {
        if (e instanceof Error && canRetry(e)) return await callback();
        throw e;
    }
}
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "retryOnce", {
    enumerable: !0,
    get: function() {
        return retryOnce;
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL3JldHJ5T25jZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENhbGxzIHRoZSBnaXZlbiBjYWxsYmFjaywgYW5kIHJldHJpZXMgb25jZSBpZiB0aGUgZXJyb3IgbWVldHMgY29uZGl0aW9ucy5cbiAqXG4gKiBAcGFyYW0gY2FsbGJhY2sgRnVuY3Rpb24gdG8gYXR0ZW1wdC5cbiAqIEBwYXJhbSBjYW5SZXRyeSBDb25kaXRpb24gb2YgdGhlIEVycm9yIHRvIHJldHJ5IG9uY2UuXG4gKi9cbmV4cG9ydCBhc3luYyBmdW5jdGlvbiByZXRyeU9uY2U8VD4oXG4gICAgY2FsbGJhY2s6ICgpID0+IFByb21pc2U8VD4sXG4gICAgY2FuUmV0cnk6IChlOiBFcnJvcikgPT4gYm9vbGVhbixcbik6IFByb21pc2U8VD4ge1xuICAgIHRyeSB7XG4gICAgICAgIHJldHVybiBhd2FpdCBjYWxsYmFjaygpXG4gICAgfSBjYXRjaCAoZSkge1xuICAgICAgICBpZiAoZSBpbnN0YW5jZW9mIEVycm9yICYmIGNhblJldHJ5KGUpKSB7XG4gICAgICAgICAgICByZXR1cm4gYXdhaXQgY2FsbGJhY2soKVxuICAgICAgICB9XG4gICAgICAgIHRocm93IGVcbiAgICB9XG59XG4iXSwibmFtZXMiOlsicmV0cnlPbmNlIiwiY2FsbGJhY2siLCJjYW5SZXRyeSIsImUiLCJFcnJvciJdLCJtYXBwaW5ncyI6IjtBQU1PLGVBQWVBLFVBQ2xCQyxRQUEwQixFQUMxQkMsUUFBK0I7SUFFL0IsSUFBSTtRQUNBLE9BQU8sTUFBTUQ7SUFDakIsRUFBRSxPQUFPRSxHQUFHO1FBQ1IsSUFBSUEsYUFBYUMsU0FBU0YsU0FBU0MsSUFDL0IsT0FBTyxNQUFNRjtRQUVqQixNQUFNRTtJQUNWO0FBQ0o7OzttQ0Fac0JIOzs7ZUFBQUEifQ==